import { defineComponent, createElementBlock, openBlock, withDirectives, createElementVNode, Fragment, renderList, toDisplayString, vShow, createTextVNode } from 'vue';

const _hoisted_1 = { class: "auto-suggestions" };
const _hoisted_2 = ["id", "aria-label"];
const _hoisted_3 = ["id", "aria-selected"];
const _hoisted_4 = { class: "auto-suggestions__list-item-element" };
const _hoisted_5 = {
  class: "visually-hidden",
  role: "status",
  "aria-live": "assertive",
  "aria-atomic": "true"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AutoSuggestions",
  props: {
    id: {},
    label: {},
    items: {},
    resultsFoundText: {},
    noResultsText: {}
  },
  emits: ["selected"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const onMouseDown = (event) => {
      event.preventDefault();
    };
    const onClick = (event) => {
      const target = event.target;
      const targetText = target.innerText;
      const item = props.items.find((item2) => item2.text === targetText);
      if (item) {
        emit("selected", item, event);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        withDirectives(createElementVNode("ul", {
          role: "listbox",
          id: _ctx.id,
          class: "auto-suggestions__list",
          "aria-label": _ctx.label,
          onMousedown: _cache[0] || (_cache[0] = ($event) => onMouseDown($event)),
          onClick: _cache[1] || (_cache[1] = ($event) => onClick($event))
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (suggestion, index) => {
            return openBlock(), createElementBlock("li", {
              key: suggestion.text,
              role: "option",
              id: `${_ctx.id}-${index}`,
              class: "auto-suggestions__list-item",
              "aria-selected": suggestion.selected
            }, [
              createElementVNode("span", _hoisted_4, toDisplayString(suggestion.text), 1)
            ], 8, _hoisted_3);
          }), 128))
        ], 40, _hoisted_2), [
          [vShow, _ctx.items && _ctx.items.length > 0]
        ]),
        withDirectives(createElementVNode("div", _hoisted_5, [
          _ctx.items.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(_ctx.items.length) + " " + toDisplayString(_ctx.resultsFoundText), 1)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(_ctx.noResultsText), 1)
          ], 64))
        ], 512), [
          [vShow, _ctx.items]
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
